module.exports = __webpack_public_path__ + "media/ganondorf.4886ca33.wav";